'use client';

import { useEffect, useState } from 'react';
import { DMImage } from '@/components/custom-image/custom-image';
import DMDialog from '@/components/dialog';
import LevelUpCarousel from '@/components/level-up/level-carousel';
import { badges } from '@/lib/badges';
import { cn } from '@/lib/utils';
import useLoyaltyStore from '@/lib/zustand/store/loyaltyStore';
import { Loader } from 'lucide-react';
import LevelBadges from './components/level-badges';

type PropLevelUpDetails = { isOpen?: boolean };
const LevelUpDetails = ({ isOpen }: PropLevelUpDetails) => {
  const [badge, setBadge] = useState('');
  const { loyaltyData: userData } = useLoyaltyStore();

  useEffect(() => {
    if (userData) {
      getLevelIcon(userData?.userLevel?.level);
    }
  }, [userData]);

  const getLevelIcon = (level: number) => {
    const item: any = badges.filter(badge => {
      if (badge.level == level) return badge;
    });
    setBadge(item[0]?.icon ?? badges[0]?.icon);
  };

  if (!userData) {
    return (
      <div>
        <Loader className='animate-spin opacity-45' />
      </div>
    );
  }

  return (
    <DMDialog
      className='max-w-[850px] w-[95%]'
      triggerContent={
        <div
          className={cn(
            `-mr-1 transition-all duration-150 hover:bg-slate-800 rounded-lg p-1 effect-shine`,
            {
              'mt-7 -mr-8': isOpen,
            }
          )}
        >
          {badge && (
            <DMImage src={badge} alt='Badge' width={isOpen ? 52 : 24} height={isOpen ? 52 : 24} />
          )}
        </div>
      }
      content={
        <div className='flex flex-col items-center justify-start gap-1 sm:gap-10 2xl:gap-16 max-w-[1400px] w-full overflow-clip'>
          <div className='flex flex-col items-center mb-2 p-6'>
            <p className='text-xs text-brand-primary'>Level</p>
            <h3 className='text-white mt-2'>{userData?.userLevel?.name}</h3>
          </div>
          {userData && <LevelUpCarousel point={userData?.xp as number} />}
          <LevelBadges />
        </div>
      }
    />
  );
};

export default LevelUpDetails;
